/**
 * array-segments.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Pipe, PipeTransform } from "@angular/core";

/**
 * The {@link ArraySegmentsPipe} splits an array into evenly sized subarrays.
 */
@Pipe({name: "segments"})
export class ArraySegmentsPipe implements PipeTransform {
  /**
   * Verify the input is an array, then join its elements using the provided
   * delimeter, or by default, a comma and space.
   * @param  {any[]}     value
   * @param  {dtring} delimiter
   * @return {any}
   */
  public transform (value : any[], pieces : number = 2) : any
  {
    if (value === null)
    {
      return null;
    }
    if (value === undefined)
    {
      return undefined;
    }
    if (!Array.isArray(value))
    {
      console.warn("Join pipe operating on non-array:", value);
      return [value];
      // throw new Error("Join only works on arrays!");
    }

    const length : number = Math.ceil(value.length / pieces);
    const subarrays : any[] = [];
    for (let i : number = 0; i < pieces; i ++)
    {
      subarrays[i] = value.slice(i * length, (i + 1) * length);
    }
    return subarrays;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/array-segments.pipe.ts